export default "__VITE_ASSET__B4YWOV7J__"